<template>
  <div style="background:#fff;">
    <Top ref="child" />
    <!-- 主体内容---开始 -->
    <div class="mianbox container">
      <div class="pub clearfix">

        <!-- 导航 -->
        <div class="position2">
          &nbsp;您当前位置：
          <span style="text-align:left">
            <router-link to="/">首页</router-link>
          </span> &gt;
          <span>
            <router-link :to="navhref">{{navtitle}}</router-link>
          </span>
        </div>


        <!-- 补充的园区搜索功能 ---start -->
        <div class="input_box search-bottom" v-show="yuanquShow">
          <ul class="screen clearfix">
            <li class="fl">
              <div class="wrap">
                <el-select
                  v-model="yuanquCountry"
                  @change="getCountry"
                  filterable
                  clearable
                  placeholder="请选择国家"
                  size="medium"
                >
                  <el-option
                    v-for="item in yuanquCountries"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </li>
            <li class="fl">
              <div class="wrap">
                <el-select v-model="yuanquProvince" @change="getProvince" filterable clearable placeholder="请选择省市" size="medium">
                  <el-option
                    v-for="item in yuanquProvinces"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </li>
            <li class="fl">
              <div class="wrap">
                <el-select v-model="isNational" @change="getNational" filterable clearable placeholder="是否为国家级" size="medium">
                  <el-option
                    v-for="item in isNationals"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </li>
          </ul>
          <div class="yq_sxmain">
            <ul class="fl yq_ul">
              <li v-show="yuanquDateShow" v-for="item in yuanquList" :key="item.id">
                <a href="javascript:;;" class="yq_ul_a" @click="yuanquClick(item.text)">{{item.text}}</a>
              </li>
              <li v-show="yuanquNodateShow" class="yq_ul_a">暂无数据</li>
            </ul>
          </div>
        </div>
        <div class="clear"></div>
        <!-- 补充的园区搜索功能 ---end-->


        <!-- 左侧合作区 -->
        <div class="pub_left1">
          <!-- 国别 -->
          <div class="left-gj" :style="{display:gb}">
            <div class="letter">
              <ul v-for="(item,index) in doccountry" :key="item.name">
                <li style="list2gbli">
                  <a
                    :id="'countryletter'+item.name"
                    @click="changecountry(item.name,index)"
                  >{{item.name}}</a>
                </li>
              </ul>
              <div :style="'padding-left:'+ letterleft + 'px'" class="card"></div>
            </div>
            <div v-for="(item,index) in doccountry" :key="item.name">
              <div class="gq" :id="'letter_'+item.name" v-show="isShowCountry === index">
                <ul v-for="itemstate in item.states" :key="itemstate.name">
                  <li class="cselect">
                    <img
                      :src="require('../../assets/imgs/flag/'+itemstate+'.png')"
                      alt
                      width="30"
                      height="20"
                    />
                    &nbsp;
                    <a href="javascript:;;" @click="countryClick(itemstate)">{{itemstate}}</a>
                    <!-- <router-link
                      :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:itemstate}}"
                    >{{itemstate}}</router-link> -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 国别基本信息 -->
          <div class="Country" :style="{display:gbinfo}">
            <div class="name">
              <img :src="addgbinfosrc()" width="37" height="25" />
              <span class="name_z" id="countryname">{{attr}}</span>
              <span
                class="name_d"
              >{{englishName!=null ?englishName.toString().substring(0,1).toUpperCase():englishName}}</span>
              <span
                class="name_s"
              >{{englishName!=null ?englishName.toString().split(',')[0].substring(1,englishName.toString().length):englishName}}</span>
            </div>
            <div>
              <div class="tp_left">
                <img :src="addgbsrc()" width="216" height="232" />
              </div>
              <div class="js_right">
                <p style="text-indent:2em" :title="introduction">{{introduction}}</p>
                <div class="js_right2">
                  <ul>
                    <ul v-for="item in docs" :key="item.code">
                      <li>
                        <a
                          :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid='+item.chnid+'&leafid='+item.leafid+'&docid='+item.code.substring(4,item.code.length)+'&uid='+item.uid+'&version=YDYL'"
                          target="_blank"
                        >【{{item.title.replace(attr,"")}}】</a>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>


          <!-- 省市 -->
          <div class="left-gj" :style="{display:ss}">
            <div class="ss">
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'安徽'}}"
                :class="$route.query.attr=='安徽' || $route.query.attr==''?'asel':''"
              >安徽</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'北京'}}"
                :class="{'asel':$route.query.attr=='北京'}"
              >北京</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'重庆'}}"
                :class="{'asel':$route.query.attr=='重庆'}"
              >重庆</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'福建'}}"
                :class="{'asel':$route.query.attr=='福建'}"
              >福建</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'甘肃'}}"
                :class="{'asel':$route.query.attr=='甘肃'}"
              >甘肃</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'广东'}}"
                :class="{'asel':$route.query.attr=='广东'}"
              >广东</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'广西'}}"
                :class="{'asel':$route.query.attr=='广西'}"
              >广西</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'贵州'}}"
                :class="{'asel':$route.query.attr=='贵州'}"
              >贵州</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'海南'}}"
                :class="{'asel':$route.query.attr=='海南'}"
              >海南</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'河北'}}"
                :class="{'asel':$route.query.attr=='河北'}"
              >河北</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'河南'}}"
                :class="{'asel':$route.query.attr=='河南'}"
              >河南</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'湖南'}}"
                :class="{'asel':$route.query.attr=='湖南'}"
              >湖南</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'湖北'}}"
                :class="{'asel':$route.query.attr=='湖北'}"
              >湖北</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'吉林'}}"
                :class="{'asel':$route.query.attr=='吉林'}"
              >吉林</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'江苏'}}"
                :class="{'asel':$route.query.attr=='江苏'}"
              >江苏</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'江西'}}"
                :class="{'asel':$route.query.attr=='江西'}"
              >江西</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'辽宁'}}"
                :class="{'asel':$route.query.attr=='辽宁'}"
              >辽宁</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'宁夏'}}"
                :class="{'asel':$route.query.attr=='宁夏'}"
              >宁夏</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'青海'}}"
                :class="{'asel':$route.query.attr=='青海'}"
              >青海</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'山东'}}"
                :class="{'asel':$route.query.attr=='山东'}"
              >山东</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'山西'}}"
                :class="{'asel':$route.query.attr=='山西'}"
              >山西</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'陕西'}}"
                :class="{'asel':$route.query.attr=='陕西'}"
              >陕西</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'上海'}}"
                :class="{'asel':$route.query.attr=='上海'}"
              >上海</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'四川'}}"
                :class="{'asel':$route.query.attr=='四川'}"
              >四川</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'天津'}}"
                :class="{'asel':$route.query.attr=='天津'}"
              >天津</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'西藏'}}"
                :class="{'asel':$route.query.attr=='西藏'}"
              >西藏</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'新疆'}}"
                :class="{'asel':$route.query.attr=='新疆'}"
              >新疆</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'云南'}}"
                :class="{'asel':$route.query.attr=='云南'}"
              >云南</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'浙江'}}"
                :class="{'asel':$route.query.attr=='浙江'}"
              >浙江</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'内蒙古'}}"
                :class="{'asel':$route.query.attr=='内蒙古'}"
              >内蒙古</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'黑龙江'}}"
                :class="{'asel':$route.query.attr=='黑龙江'}"
              >黑龙江</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'香港'}}"
                :class="{'asel':$route.query.attr=='香港'}"
              >香港</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'澳门'}}"
                :class="{'asel':$route.query.attr=='澳门'}"
              >澳门</router-link>
              <router-link
                :to="{path: '/lit/channel2', query:{ uid: $route.query.uid,subuid: $route.query.subuid,attr:'台湾'}}"
                :class="{'asel':$route.query.attr=='台湾'}"
              >台湾</router-link>
              <div class="clear"></div>
              <div></div>
            </div>
          </div>


          <!-- 园区目录基本信息 -->
          <div class="card_b" :style="{display:yqinfo}">
            <div class="Country" name="country">
              <div class="name">
                <img src="../../assets/imgs/mulu_imgf.png" width="37" height="25" />
                <span class="name_z" id="countryname">{{yqname}}</span>
              </div>
              <div>
                <div class="tp_left">
                  <img :src="addyqsrc()" width="216" height="232" />
                </div>
                <div class="js_right">
                  {{yqcontent}}
                  <div class="js_right2">
                    <ul></ul>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </div>
          <!-- 各栏目 -->
          <div class="card_b">
            <!-- 国别栏目 -->
            <div class="morebt" :style="{display:gbDisplay}">
              <ul v-for="(item,index) in channels" :key="item.uid" :id="'gb'+item.uid">
                <li v-if="item.count>0 && item.text!='数据'">
                  <router-link
                    :to="{path: '/lit/channel2', query:{ uid: uid4,subuid:item.uid,attr:attr}}"
                    :class="[ item.uid === countrynewSubuid ? 'tab1' : 'tab2' ]"
                  >{{item.text}}</router-link>
                </li>
                <!-- 因为有的countryid是null，因此加了个判断 -->
                <li v-if="item.text==='数据' &&  item.countryid!='null'">
                  <router-link
                    :to="{path: '/db/DbusinessS', query:{ countryid: item.countryid}}"
                    class="tab2"
                  >数据</router-link>
                </li>
              </ul>
            </div>
            <!-- 省市栏目 -->
            <div class="morebt" :style="{display:ssDisplay}">
              <ul v-for="(item,index) in sschannels" :key="item.uid" :id="'ss'+item.uid">
                <li v-if="item.count>0">
                  <router-link
                    :to="{path: '/lit/channel2', query:{ uid: uid4,subuid:item.uid,attr:attr}}"
                    class="tab2"
                  >{{item.text}}</router-link>
                </li>
              </ul>
            </div>
            <!-- 园区栏目 -->
            <div class="morebt" :style="{display:yqDisplay}">
              <ul v-for="(item,index) in yqchannels" :key="item.uid" :id="'yq'+item.uid">
                <li v-if="item.count>0">
                  <router-link
                    :to="{path: '/lit/channel2', query:{ uid: uid4,subuid:item.uid,attr:yqname}}"
                     :class="[ item.uid === newSubuid ? 'tab1' : 'tab2' ]"
                  >{{item.text}}</router-link>
                </li>
              </ul>
            </div>
            <!-- 文献 -->
            <router-view></router-view>
          </div>
        </div>


        <!-- 右侧重点报告 -->
        <div class="pub_right1 yahei">
          <router-link :to="{ path: '/lit/list', query:{ uid: 8003 }}">
            <img
              src="../../assets/imgs/img_zdbg.png"
              usemap="#Map"
              width="367"
              height="21"
              border="0"
            />
          </router-link>

          <ul class="pub_wz zdbg">
            <li v-for="item in zdbgListdata" :key="item.code">
              <a
                name="subject"
                :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid='+item.chnid+'&leafid='+item.leafid+'&docid='+item.code.substring(4,item.code.length)+'&uid='+item.uid+'&version=YDYL'"
                title="item.title"
                target="_blank"
              >{{ item.title | titleellipsis}}</a>
              <p>
                <span name="summary">{{ item.summary | summaryellipsis}}</span>
              </p>
            </li>
          </ul>
        </div>


      </div>
    </div>
    <!-- 主体内容---结束 -->
    <!-- 右侧联系方式  -->
    <rightnav></rightnav>
    <backTop />
    <Footerc />
  </div>
</template>
<script>
import Top from "@/components/top";
import Footerc from "@/components/footerchannel";
import backTop from "@/components/BackTop";
import rightnav from "@/components/rightnav";
import { api } from "@/require/api";

export default {
  name: "list2",
  components: {
    Top,
    Footerc,
    rightnav,
    backTop
  },
  data() {
    return {
      // 园区搜索
      yuanquCountries: [],
      yuanquCountry: "",
      yuanquProvinces: [],
      yuanquProvince: "",
      isNationals: [],
      isNational: "",
      yuanquList: [],
      yuanquDateShow: true,
      yuanquNodateShow: false,
      yuanquShow: true,
      yuanquTabSubuid: "",
      yuanquTabSubuidName: '',
      yqchannels_created: [],
      newSubuid: '',
      countrynewSubuid: '8004',
      countryTabSubuid: '',
      
      // 园区搜索


      uid: "", //url参数
      uid4: "", //4位长度的uid
      attr: "",
      subuid: "", //栏目id

      picDisplay: "none", //右侧联系方式
      phoneDisplay: "none",
      xsDisplay: "none",
      mailDisplay: "none",
      isShow: false, //右侧联系方式中回到顶部

      navtitle: "", //根据uid显示不同nav
      gb: "none", //国别
      gbinfo: "none", //国家信息
      ss: "none", //省市
      yqinfo: "none", //园区目录信息
      gbDisplay: "none", //国别栏目
      ssDisplay: "none", //省市栏目
      yqDisplay: "none", //园区栏目
      ydpicid: "a默认图",
      yqname: "",
      yqcontent: "",

      doccountry: [], //国家列表
      englishName: "", //国家基本信息
      introduction: "",

      isShowCountry: 0, //这里默认为0，取到itemList数组里面第一条数据
      letterleft: "", //国别区域距左距离

      docs: [],
      channels: [],
      sschannels: [],
      yqchannels: [],

      yqmodel: [], //园区基本信息
      yuanquName: "", //参数园区名称

      zdbgListdata: [],

      channelname: "", //点击某个栏目切换样式

      docListdata: [], //右侧docs

      errorImg01:
        'this.src="' + require("../../assets/imgs/map/default.gif") + '"'
    };
  },
  filters: {
    //文章标题截取
    titleellipsis(value) {
      if (!value) return "";
      if (value.length > 17) {
        return value.slice(0, 17) + "...";
      }
      return value;
    },
    //文章简介截取
    summaryellipsis(value) {
      if (!value) return "";
      if (value.length > 40) {
        return value.slice(0, 40) + "...";
      }
      return value;
    }
  },
  created() {
    // 园区
    if(this.$route.query.uid === "8012"){
      // 园区搜索
      this.yuanquShow = true
      this.loadZoneBoxList();
      this.loadZoneBoxResult();

      // 园区Tab切换
      this.loadyqmodel_created();

    }else{
      this.yuanquShow = false
    }

    // 国别
    if(this.$route.query.uid === "8013"){
      this.attr = this.$route.query.attr;
      this.loadcountry();
      this.loadcountrymodel();
    }

    // 省市
    if(this.$route.query.uid === "8014"){
      this.attr = this.$route.query.attr;
      this.loadcitychannel();
    }
    this.uid = this.$route.query.uid;
    this.uid4 = this.uid.toString().substring(0, 4);
    this.subuid = this.$route.query.subuid; //栏目id
    this.attr = this.$route.query.attr;

    this.shownav(this.uid4); //根据uid显示不同nav
    this.showModular(this.uid); //根据uid显示不同模块
    
    this.loadzdbgdocs();

    this.addgbsrc();
    this.addyqsrc();
    this.addgbinfosrc();
  },
  mounted() {
    // window.addEventListener("scroll", this.scrollToTop); //右侧联系方式-回到顶部
    // 顶部查询显示
    this.$refs.child.isShowsearch = true;
    this.$refs.child.ischannelright = true;
  },
  watch: {
    // channels: function() {
    //   this.$nextTick(function() {
    //     this.subuid = this.$route.query.subuid;
    //     $("#gb" + this.subuid)
    //       .find("a")
    //       .removeClass("tab2")
    //       .addClass("tab1");
    //     $("#gb" + this.subuid)
    //       .siblings()
    //       .find("a")
    //       .removeClass("tab1")
    //       .addClass("tab2");
    //   });
    // },
    sschannels: function() {
      this.$nextTick(function() {
        this.subuid = this.$route.query.subuid;
        $("#ss" + this.subuid)
          .find("a")
          .removeClass("tab2")
          .addClass("tab1");
        $("#ss" + this.subuid)
          .siblings()
          .find("a")
          .removeClass("tab1")
          .addClass("tab2");
      });
    },
    yqchannels: function() {
      this.$nextTick(function() {
        this.subuid = this.$route.query.subuid;
        $("#yq" + this.subuid)
          .find("a")
          .removeClass("tab2")
          .addClass("tab1");
        $("#yq" + this.subuid)
          .siblings()
          .find("a")
          .removeClass("tab1")
          .addClass("tab2");
      });
    },

    $route: function() {
      this.newSubuid = this.$route.query.subuid 
      // 园区
      if(this.$route.query.uid === "8012"){
        // 园区搜索
        this.yuanquShow = true
        this.loadZoneBoxList();
        this.loadZoneBoxResult(); 
        this.subuid = this.$route.query.subuid;
        $("#yq" + this.subuid)
          .find("a")
          .removeClass("tab2")
          .addClass("tab1");
        $("#yq" + this.subuid)
          .siblings()
          .find("a")
          .removeClass("tab1")
          .addClass("tab2");
      }else{
        this.yuanquShow = false
      }

      // 国别
      if(this.$route.query.uid === "8013"){
        this.countrynewSubuid = this.$route.query.subuid
        this.attr = this.$route.query.attr;
        this.subuid = this.$route.query.subuid;
        this.loadcountry();
        this.loadcountrymodel();
        $("#gb" + this.subuid)
          .find("a")
          .removeClass("tab2")
          .addClass("tab1");
        $("#gb" + this.subuid)
          .siblings()
          .find("a")
          .removeClass("tab1")
          .addClass("tab2");
      }
      if(this.$route.query.uid === "8014"){
        this.attr = this.$route.query.attr;
        this.loadcitychannel();
      }
      this.uid = this.$route.query.uid;
      this.uid4 = this.uid.toString().substring(0, 4);
      this.subuid = this.$route.query.subuid; //栏目id
      this.attr = this.$route.query.attr;

      this.shownav(this.uid4); //根据uid显示不同nav
      this.showModular(this.uid4);

      this.addgbsrc();
      this.addyqsrc();
      this.addgbinfosrc();
       this.subuid = this.$route.query.subuid;
        $("#yq" + this.subuid)
          .find("a")
          .removeClass("tab2")
          .addClass("tab1");
        $("#yq" + this.subuid)
          .siblings()
          .find("a")
          .removeClass("tab1")
          .addClass("tab2");
    }
  },
  methods: {
    // 园区搜索
    async loadZoneBoxList() {
      const { code, data } = await api.get(
        "/documentController/getZoneBoxList"
      );
      if (code === 0) {
        this.yuanquCountries = data.states;
        this.yuanquProvinces = data.provinces;
        this.isNationals = data.zoneTypes;
      }
    },
    async loadZoneBoxResult() {
      let query = "";
      if (
        this.yuanquCountry === "" &&
        this.yuanquProvince === "" &&
        this.isNational === ""
      ) {
        query = {};
      } else {
        query = {
          state: this.yuanquCountry,
          province: this.yuanquProvince,
          zoneType: this.isNational
        };
      }
      const { code, data } = await api.get(
        "/documentController/getZoneBoxResult",
        query
      );
      if (code === 0) {
        data.length > 0
          ? ((this.yuanquList = data),
            (this.yuanquDateShow = true),
            (this.yuanquNodateShow = false))
          : ((this.yuanquDateShow = false), (this.yuanquNodateShow = true));
      }
    },
    getCountry() {
      this.loadZoneBoxResult();
      this.yuanquList = [];
    },
    getProvince() {
      this.loadZoneBoxResult();
      this.yuanquList = [];
    },
    getNational() {
      this.loadZoneBoxResult();
      this.yuanquList = [];
    },
    yuanquClick(value){
      this.yuanquName = value
      this.loadyqmodel().then(()=>{
        this.$router.push({
          path: '/lit/list2',
          query: {uid: '8012',subuid: this.yuanquTabSubuid,attr:this.yuanquName}
        }); 
        $("#yq" + this.yuanquTabSubuid)
          .find("a")
          .removeClass("tab2")
          .addClass("tab1");
        $("#yq" + this.yuanquTabSubuid)
          .siblings()
          .find("a")
          .removeClass("tab1")
          .addClass("tab2");
      }) 
    },
    countryClick(value){
      this.yuanquName = value
      this.loadcountrymodel().then(()=>{
        this.$router.push({
          path: '/lit/list2',
          query: {uid: '8013',subuid: this.countryTabSubuid,attr:this.yuanquName}
        }); 
        // $("#yq" + this.yuanquTabSubuid)
        //   .find("a")
        //   .removeClass("tab2")
        //   .addClass("tab1");
        // $("#yq" + this.yuanquTabSubuid)
        //   .siblings()
        //   .find("a")
        //   .removeClass("tab1")
        //   .addClass("tab2");
      }) 
    },


    //根据uid显示location名称
    shownav(uid4) {
      if (uid4.indexOf("8013") !== -1) {
        this.navhref = "/lit/channel2?uid=8013&subuid=8004&attr=阿富汗";
        this.navtitle = "国别";
      } else if (uid4.indexOf("8014") !== -1) {
        this.navhref = "/lit/channel2?uid=8014&subuid=8004&attr=安徽";
        this.navtitle = "省市";
      } else if (uid4.indexOf("8012") !== -1) {
        this.navhref = "/lit/channel?uid=8012";
        this.navtitle = "园区";
      }
    },
    //根据uid显示不同模块
    showModular(uid4) {
      this.gb = "none";
      this.gbinfo = "none";
      this.ss = "none";
      this.yqinfo = "none";
      this.gbDisplay = "none";
      this.ssDisplay = "none";
      this.yqDisplay = "none";

      if (uid4.indexOf("8013") !== -1) {
        //国别
        this.gb = "block";
        this.gbinfo = "block";
        this.gbDisplay = "block";
      } else if (uid4.indexOf("8014") !== -1) {
        //省市
        this.ss = "block";
        this.ssDisplay = "block";
      } else if (uid4.indexOf("8012") !== -1) {
        //园区
        this.yqinfo = "block";
        this.yqDisplay = "block";
      }

      // 初始化当前页

      this.uid = this.$route.query.uid;
      this.uid4 = this.uid.toString().substring(0, 4);
      this.subuid = this.$route.query.subuid; //栏目id
      this.attr = this.$route.query.attr;
    },
    //国别基本信息国旗
    addgbinfosrc() {
      try {
        let yqinfoimgs = require("../../assets/imgs/flag/" +
          this.attr +
          ".png");
        return yqinfoimgs;
      } catch (err) {
        let yqinfeorrorimg = require("../../assets/imgs/flag/default.png");
        return yqinfeorrorimg;
      }
    },
    //国别基本信息默认图
    addgbsrc() {
      try {
        let gbimgs = require("../../assets/imgs/map/" +
          this.englishName +
          ".gif");
        return gbimgs;
      } catch (err) {
        let gberrorimg = require("../../assets/imgs/map/default.gif");
        return gberrorimg;
      }
    },
    //园区基本信息默认图
    addyqsrc() {
      try {
        let yqimgs = require("../../assets/imgs/yuanqu/" +
          this.ydpicid +
          ".jpg");
        return yqimgs;
      } catch (err) {
        let yqerrorimg = require("../../assets/imgs/yuanqu/default.jpg");
        return yqerrorimg;
      }
    },


    //获取文章列表
    async loadzdbgdocs() {
      this.loading = true;
      const { code, data } = await api.get(
        "/documentController/getPageChannelDocumentsByUId",
        {
          uid: "8003",
          curPage: 1,
          pageSize: 13
        }
      );
      if (code === 0) {
        this.zdbgListdata = data.data;
      }
    },
    //国别列表
    async loadcountry() {
      const { code, data } = await api.get("/documentController/getStateList");
      if (code === 0) {
        this.doccountry = data;
      }
    },
    //国别基本信息
    async loadcountrymodel() {
      $(".js_right").hide(); //因为接口返回慢，因此这里先隐藏
      const {
        firstChar,
        englishName,
        docs,
        channels,
        countryName,
        introduction
      } = await api.get("/documentController/getCountryInfo", {
        countryName: this.attr
      });
      if (countryName != null) {
        $(".js_right").show(); //接口返回数据后，显示
        this.englishName = englishName;
        this.docs = docs;
        this.channels = channels;
        this.attr = countryName;
        this.introduction = introduction;
        
        let tabData = 0
        for (let i = 0; i < channels.length; i++) {
          if(channels[i].uid === "8004"){
            tabData = tabData + 1
          } 
        }
        if (tabData === 0) {
          this.countryTabSubuid = channels[0].uid
        }else if(tabData === 1){
          this.countryTabSubuid = "8004"
        }
      }
    },
    //省市栏目
    async loadcitychannel() {
      const { code, data } = await api.get("/documentController/getCityInfo", {
        city: this.attr
      });
      if (code === 0) {
        this.sschannels = data;
      }
    },

    //园区基本信息
    async loadyqmodel() {
      const { code, data } = await api.get("/documentController/getZoneInfo", {
        yuanquName: this.yuanquName
      });
      if (code === 0) {
        this.ydpicid = data.yuanquPicId;
        this.yqname = data.yuanquName;
        this.yqcontent = data.yuanquContent;
        this.yqchannels = data.yuanquChannel;
        if(data.yuanquChannel.length === 0)
        {
          this.yuanquTabSubuid = ""
          return
        }
        let tabData = 0
        for (let i = 0; i < data.yuanquChannel.length; i++) {
          if(data.yuanquChannel[i].uid === "801202"){
            tabData = tabData + 1
          } 
        }
        if (tabData === 0) {
          this.yuanquTabSubuid = data.yuanquChannel[0].uid
        }else if(tabData === 1){
          this.yuanquTabSubuid = "801202"
        }
      }
    },
    //园区基本信息
    async loadyqmodel_created() {
      this.yuanquName = this.$route.query.attr;
      const { code, data } = await api.get("/documentController/getZoneInfo", {
        yuanquName: this.yuanquName
      });
      if (code === 0) {
        this.ydpicid = data.yuanquPicId;
        this.yqname = data.yuanquName;
        this.yqcontent = data.yuanquContent;
        this.yqchannels = data.yuanquChannel;
        if(data.yuanquChannel.length === 0)
        {
          this.yuanquTabSubuid = ""
          return
        }
        let tabData = 0
        for (let i = 0; i < data.yuanquChannel.length; i++) {
          if(data.yuanquChannel[i].uid === "801202"){
            tabData = tabData + 1
          } 
        }
        if (tabData === 0) {
          this.yuanquTabSubuid = data.yuanquChannel[0].uid
        }else if(tabData === 1){
          this.yuanquTabSubuid = "801202"
        }
      }
    },
    //国别切换
    changecountry(letter, index) {
      if (this.isShowCountry === index) {
        this.isShowCountry = -1; //在这里就将它赋值为-1  由于：-1 !=  index 所以其他内容隐藏 ，被点击的则打开
      } else {
        this.isShowCountry = index; //这里是把index赋值给isShow，isShow=index则显示
      }

      let lettera = document.getElementById("countryletter" + letter);
      this.letterleft = lettera.getBoundingClientRect().left;
      this.letterleft = 60 + index * 68.5;
    },
    //获取文章列表
    // async loaddocs() {
    //   const { code, data } = await api.get(
    //     "/documentController/getPageChannelDocumentsByUId",
    //     {
    //       uid: this.uid,
    //       attr: this.attr,
    //       curPage: this.currentPage,
    //       pageSize: this.pageSize
    //     }
    //   );
    //   if (code === 0) {
    //     this.total = data.totlalCount;
    //     this.docListdata = data.data;
    //   }
    // },


    //右侧联系方式-回到顶部是否显示
    scrollToTop() {
      if (document.documentElement.scrollTop > 100) {
        this.isShow = true;
      } else if (document.documentElement.scrollTop < 100) {
        this.isShow = false;
      }
    },
    //右侧联系方式-回到顶部
    backTop() {
      let timer = setInterval(() => {
        let top = document.documentElement.scrollTop;
        let speed = Math.ceil(top / 5);
        document.documentElement.scrollTop = top - speed;
        if (top === 0) {
          clearInterval(timer);
        }
      }, 20);
    },
    //右侧联系方式-鼠标移上显示对应的
    secondShow(num) {
      if (num === 1) {
        this.picDisplay = "block";
      } else if (num === 2) {
        this.phoneDisplay = "block";
      } else if (num === 3) {
        this.xsDisplay = "block";
      } else if (num === 4) {
        this.mailDisplay = "block";
      }
    },
    //右侧联系方式-鼠标移开隐藏对应的
    secondHide(num) {
      if (num === 1) {
        this.picDisplay = "none";
      } else if (num === 2) {
        this.phoneDisplay = "none";
      } else if (num === 3) {
        this.xsDisplay = "none";
      } else if (num === 4) {
        this.mailDisplay = "none";
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop); //右侧联系方式-回到顶部
  }
};
</script>

<style lang='less' scoped>
/deep/.guides{
  display: none!important;
}
/*园区搜索框样式*/
.screen li {
  width: 33.33%;
  padding: 5px 15px;
}
.input_box {
  background: url(../../assets/imgs/yq_bj.jpg) no-repeat top;
  width: 100%;
  height: 190px;
  overflow-y: auto;
  background-size: 100% 100%;
  margin-top: 10px;
  padding-top: 10px;
}
.yq_sxmain {
  width: 100%;
  height: 120px;
  margin-top: 6px;
  overflow-y: auto;
}
.yq_ul {
  width: 100%;
  padding: 0px 10px;
}
.yq_ul li {
  width: 33.3%;
  display: inline-block;
}
.yq_ul a {
  color: #333;
  line-height: 28px;
}

.yq_ul_a {
  background: url(../../assets/imgs/jt.png) no-repeat left;
  color: #333;
  line-height: 28px;
  padding-left: 15px;
  padding-left: 19px;
  margin-left: 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 95%;
  display: block;
}
.search-bottom {
  /deep/.el-input__inner {
    border: 1px solid #e8b682 !important;
    border-radius: 5px;
    background: #fffbdf !important;
    color: #b37c4b;
  }
}

.el-select {
  width: 100%;
}
// 园区搜索样式结束
.header_bj {
  background: url(../../assets/imgs/navtop2.jpg) no-repeat !important;
  background-size: 100% 100% !important;
}
/deep/.header {
  width: 1200px !important;
  margin: 0 auto !important;
}
body {
  font: 14px "微软雅黑", "microsoft yahei", "Arial Narrow", HELVETICA;
  font-weight: normal;
  font-size: 14px;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  color: #333;
  line-height: 170%;
}
/deep/img {
  border: 0;
  vertical-align: middle;
  display: inline-block;
}
a {
  text-decoration: none;
}
a:link {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}

/* font */
.fB {
  font-weight: bold;
}
.red1 {
  color: #c81623;
}
.yellow1 {
  color: #ff0;
}
.h_1 {
  color: #333;
}

/* float */
/deep/.clear {
  clear: both;
  display: block;
}
.f12 {
  font-size: 12px;
}
.f15 {
  font-size: 15px;
}
.f19 {
  font-size: 19px;
}
/* margin */
.mb10 {
  margin-bottom: 10px;
}
.mt10 {
  margin-top: 10px;
}
.pt10 {
  padding-top: 10px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.tright {
  text-align: right;
}

.lft {
  float: left;
}
.rgt {
  float: right;
  display: inline;
}
.clear {
  clear: both;
  display: block;
}

// .yahei {font-family:"Microsoft YaHei", 微软雅黑, "Microsoft JhengHei", 华文细黑, STHeiti, MingLiu;}

/*----------nav----------*/

/deep/.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

/*-------main------------*/
.mianbox {
  background-color: #fff;
  margin-top: 10px;
  padding-top: 2px;
  text-align: left;
}

.link_a {
  width: 1230px;
}
.link_a .link_b {
  background-color: #e7e7e7;
  margin: 20px 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
.link_a .link_b {
  text-align: center;
}
.link_a .link_b .link_c {
  padding: 10px;
}

.bottom_box {
  position: relative;
  text-align: center;
  overflow: hidden;
}
.homebottom {
  margin: 30px 0;
  text-align: center;
  display: inline-block;
  position: absolute;
  top: 0px;
  left: 32%;
}

/* 浮动工具条*/
.izl-rmenu .btn {
  width: 72px;
  height: 73px;
  margin-bottom: 1px;
  cursor: pointer;
  position: relative;
}
.izl-rmenu .btn-wx {
  background: url(../../assets/imgs/r_wx.png) 0px 0px no-repeat;
  background-color: #78c340;
}
.izl-rmenu .btn-wx:hover {
  background-color: #58a81c;
}
.izl-rmenu .btn-wx .pic {
  position: absolute;
  left: -160px;
  top: 0px;
  width: 160px;
  height: 160px;
  display: none;
}
.izl-rmenu .btn-phone {
  background: url(../../assets/imgs/r_phone.png) 0px 0px no-repeat;
  background-color: #fbb01f;
}
.izl-rmenu .btn-phone:hover {
  background-color: #ff811b;
}
.izl-rmenu .btn-phone .phone {
  background-color: #ff811b;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}

.izl-rmenu .btn-xs {
  background: url(../../assets/imgs/r_xs.png) 0px 0px no-repeat;
  background-color: #6cafeb;
}
.izl-rmenu .btn-xs:hover {
  background-color: #5d9fdb;
}
.izl-rmenu .btn-xs .xs {
  background-color: #5d9fdb;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}

.izl-rmenu .btn-mail {
  background: url(../../assets/imgs/r_mail.png) 0px 0px no-repeat;
  background-color: #e37677;
}
.izl-rmenu .btn-mail:hover {
  background-color: #dd6364;
}
.izl-rmenu .btn-mail .mail {
  background-color: #dd6364;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 15px;
  text-align: center;
}

.izl-rmenu .btn-top {
  background: url(../../assets/imgs/r_top.png) 0px 0px no-repeat;
  background-color: #666666;
}
.izl-rmenu .btn-top:hover {
  background-color: #444;
}

.pagingsite {
  margin-right: 10px;
  padding-top: 10px;
}

.mianbox .pub_left {
  position: relative;
  font-family: "Microsoft Yahei", "微软雅黑", "宋体", Tahoma, Arial, Helvetica,
    STHeiti;
  float: left;
  width: 305px;
  text-align: center;
  background: url(../../assets/imgs/img_bj.gif) repeat-y top;
  height: 1350px;
}

.mianbox .pub_left .h1_a {
  width: 305px;
  height: 45px;
  background: url(../../assets/imgs/img_bj2.gif) no-repeat top;
  height: 161px;
  font-size: 18px;
  line-height: 38px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 500;
}
.mianbox .pub_left .left-nav {
  // width: 302px;
  // *width: 300px;
  // padding: 0 0px 25px 0px;
  // *padding: 0;
  // text-align: center;

  *width: 282px;
  padding: 0 0px 25px 0px;
  *padding: 0;
  text-align: center;
  margin: 0 10px;
}
.mianbox .pub_left .left-nav .or {
  position: relative;
  margin-bottom: 10px;
  line-height: 40px;
  font-size: 16px;
  margin-right: 10px;
  text-align: left;
}
.mianbox .pub_left .left-nav .or h3 {
  height: 40px;
  background-color: #185bb0;
}
.mianbox .pub_left .left-nav .or .or_a a {
  color: #333;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.mianbox .pub_left .left-nav .or .or_a a:hover {
  color: #c30;
}
.mianbox .pub_left .left-nav .or a {
  color: #fff;
  margin-left: 60px;
}

.mianbox .pub_left .left-nav .or .arrow {
  color: #fff;
  float: right;
  font-size: 18px;
  padding-right: 40px;
  background: url(../../assets/imgs/icon_a.png) no-repeat center;
}

.mianbox .pub_left .left-nav .nLi {
  position: relative;
  margin-bottom: 10px;
  line-height: 40px;
  font-size: 16px;
  margin-right: 10px;
  text-align: left;
}
.mianbox .pub_left .left-nav .nLi h3 {
  height: 40px;
  background-color: #fff;
}
.mianbox .pub_left .left-nav .nLi .or_a a {
  color: #333;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.mianbox .pub_left .left-nav .nLi .or_a a:hover {
  color: #c30;
}
.mianbox .pub_left .left-nav .nLi a {
  color: #193d8a;
  position: relative;
  padding-left: 60px;
}
.mianbox .pub_left .left-nav .nLi .arrow {
  color: #193d8a;
  float: right;
  font-size: 18px;
  padding-right: 40px;
  background: url(../../assets/imgs/icon2.gif) no-repeat center;
}

/deep/.pub_right {
  float: right;
  width: 870px;
}

/deep/.card_b .main1 {
  border: #c2dbf2 1px solid;
  border-top: 2px #c2dbf2 solid;
  min-height: 850px;
}
/deep/.card_b .main1 .pub_content {
  padding: 20px;
  *padding: 0;
  *margin: 20px;
}
/deep/.card_b .main1 .extra li {
  font-size: 13px;
  float: left;
  padding-right: 10px;
  color: #333;
  line-height: 22px;
}
/deep/.card_b .main1 .list a {
  color: #1c4199;
  font-size: 16px;
}

/deep/.pub_right .pub_content .list {
  padding-bottom: 20px;
}
/deep/.pub_right .pub_content .list li .extra {
  font-size: 13px;
  margin: 5px 0px;
  text-align: left;
}
/deep/.pub_right .pub_content .list a {
  font-size: 16px;
  text-decoration: none;
  float: left;
}
/deep/.pub_right .pub_content .list a span {
  color: #1c4199;
  padding-bottom: 8px;
  display: block;
  float: left;
}
/deep/.pub_right .pub_content .list li .extra li {
  display: inline;
  color: #666;
  margin-right: 20px;
}
/deep/.pub_right .pub_content .list li .extra .author {
  margin: 0px 5px;
  color: #9b1111;
}
.pub_right .location1 {
  background: #ebebeb url(../../assets/imgs/icon_li.png) no-repeat scroll 18px;
  font-size: 15px;
  line-height: 30px;
  padding-left: 30px;
  padding-top: 2px;
}
.pub_right .pub_content {
  font-size: 14px;
  padding: 15px 0;
  border-bottom: #ccc 1px dotted;
}
/deep/.de-date {
  float: right;
}
.de-date a {
  color: #333;
  font-size: 16px;
  padding: 0 5px;
}
.de-date a:hover {
  color: #c00;
}
.disabled {
  color: #cecac5;
}

.pub_right .location {
  color: #333;
}

.position2 {
  background: #ebebeb url(../../assets/imgs/icon_li.png) no-repeat scroll 18px;
  font-size: 15px;
  line-height: 30px;
  padding-left: 50px;
  padding-top: 2px;
}
.pub_left1 {
  position: relative;
  font-family: "Microsoft Yahei", "微软雅黑", "宋体", Tahoma, Arial, Helvetica,
    STHeiti;
  float: left;
  width: 738px;
}
.pub_left1 .left-gj {
  margin-top: 15px;
}
.pub_left1 .left-gj .letter {
  text-align: left;
  width: 738px;
  z-index: 100;
  height: 50px;
}
.pub_left1 .left-gj .letter ul li {
  float: left;
  line-height: 50px;
  // width: 38px;
  // *width: 21px;
}
.pub_left1 .left-gj .letter .card {
  background: url(../../assets/imgs/tu7.gif) no-repeat bottom;
  position: relative;
  height: 14px;
  width: 16px;
  clear: both;
  bottom: 13px;
  *bottom: 12px;
  padding-left: 60px;
}
.pub_left1 .left-gj .letter a {
  padding-left: 23px;
  font-size: 17px;
  color: #333;
  cursor: pointer;
}
.pub_left1 .left-gj .letter a:hover {
  color: #c33;
}

.pub_left1 .left-gj .gq {
  height: 215px;
  width: 100%;
  border: #c4dcf1 2px solid;
}
.pub_left1 .left-gj .ss {
  border: #c4dcf1 2px solid;
  padding: 10px 10px 10px 20px;
  *height: 120px;
}
.pub_left1 .left-gj .ss a {
  color: #333;
  font-weight: bold;
  font-size: 15px;
  width: 62px;
  height: 30px;
  line-height: 30px;
  display: block;
  float: left;
  text-align: center;
}
.pub_left1 .left-gj .ss .asel {
  color: #fff;
  background-color: #3162be;
}

.pub_left1 .left-gj .ss a:hover {
  color: #c00;
}
.pub_left1 .left-gj .gq img {
  border: #ebebeb 1px solid;
}
.pub_left1 .left-gj .gq ul {
  margin: 15px;
}
.pub_left1 .left-gj .gq li {
  float: left;
  display: inline;
  width: 160px;
  padding-bottom: 20px;
  text-align: left;
  margin-left: 15px;
}
.pub_left1 .left-gj .gq li a {
  color: #333;
  font-size: 15px;
  font-weight: bold;
}
.pub_left1 .left-gj .gq li a:hover {
  color: #c00;
}

.Country .name {
  text-align: left;
  margin-top: 20px;
  width: 100%;
  border-bottom: 2px #555555 solid;
  margin-bottom: 20px;
}
.Country .name .name_z {
  font-size: 23px;
  font-weight: bold;
}
.Country .name .name_d {
  font-size: 32px;
  margin-left: 5px;
  color: #888b8e;
}
.Country .name .name_s {
  font-size: 23px;
  color: #a9aaac;
}
.Country .name img {
  margin-right: 10px;
  margin-bottom: 8px;
}
.Country .tp_left {
  float: left;
  margin-right: 20px;
  text-align: left;
  width: 220px;
}
.Country .js_right1 {
  width: 100%;
  float: right;
}
.Country .js_right1 p {
  color: #727272;
  line-height: 24px;
  font-size: 14px;
}
.Country .js_right {
  width: 490px;
  float: right;
  color: #727272;
  line-height: 24px;
  font-size: 14px;
}
.Country .js_right p {
  color: #727272;
  line-height: 24px;
  height: 188px;
  font-size: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
  overflow: hidden;
}
.Country .js_right2 {
  margin: 10px 0px;
}
.Country .js_right2 li {
  float: left;
  padding: 0px;
  font-size: 15px;
}
.Country .js_right2 li a {
  color: #012f9e;
}
.Country .js_right2 li a:hover {
  color: #c00;
  text-decoration: none;
}

.morebt {
  overflow: hidden;
  _zoom: 1;
  padding: 20px 0 0 0;
}
.morebt ul li {
  float: left;
  margin-right: 8px;
  cursor: pointer;
  line-height: 35px;
  height: 35px;
}
.morebt ul li a {
  text-align: center;
  display: block;
  padding: 0 15px;
}

.morebt1 {
  margin-top: 30px;
  overflow: hidden;
  _zoom: 1;
}
.morebt1 ul li {
  float: left;
  margin-right: 8px;
  cursor: pointer;
  line-height: 35px;
  height: 35px;
}
.morebt1 ul li a {
  text-align: center;
  display: block;
  padding: 0 15px;
}

.tab1 {
  background: #fff url(../../assets/imgs/bgnav.jpg) repeat-x;
  font-weight: 700;
  overflow: hidden;
  border: 1px #1573b4 solid;
  border-bottom: none;
  position: relative;
  bottom: -1px;
  font-size: 14px;
  color: #fff;
}

.tab2 {
  background: #f4fbff url(../../assets/imgs/bg_nav2.jpg) repeat-x bottom;
  border: 1px #bed9f0 solid;
  border-bottom: none;
  font-size: 14px;
  color: #0561a2;
  height: 32px;
  overflow: hidden;
}

.pub_right1 {
  width: 367px;
  float: right;
  margin-top: 20px;
  z-index: 1000;
}
.pub_right1 .pub_wz {
  padding: 10px 30px 10px 30px;
}
.pub_right1 .pub_wz a {
  color: #1c4199;
  font-size: 16px;
}
.pub_right1 .pub_wz a:hover {
  color: #c00;
}
.pub_right1 .pub_wz .date1 {
  float: right;
  font-size: 12px;
  color: #666;
}
.pub_right1 .pub_wz p {
  margin-top: 5px;
}
.pub_wz p {
  font-size: 14px;
  line-height: 25px;
}

.zdbg {
  background: #ebebeb none repeat scroll 0% 0%;
  height: 1285px;
}

.zdbg li {
  margin-top: 10px;
}

/deep/.mr10 {
  margin-right: 10px;
}
/deep/.mr5 {
  margin-right: 5px;
}

/* 浮动工具条*/
// .izl-rmenu{position:fixed;right:0;bottom:10px;padding-bottom:73px;background:url(../../assets/imgs/r_b.png) 0px bottom no-repeat;z-index:999;}
.izl-rmenu {
  position: fixed;
  right: 0;
  bottom: 10px;
  padding-bottom: 73px;
  z-index: 999;
}
.izl-rmenu .btn {
  width: 72px;
  height: 73px;
  margin-bottom: 1px;
  cursor: pointer;
  position: relative;
}
.izl-rmenu .btn-wx {
  background: url(../../assets/imgs/r_wx.png) 0px 0px no-repeat;
  background-color: #78c340;
}
.izl-rmenu .btn-wx:hover {
  background-color: #58a81c;
}
.izl-rmenu .btn-wx .pic {
  position: absolute;
  left: -160px;
  top: 0px;
  width: 160px;
  height: 160px;
  display: none;
}
.izl-rmenu .btn-phone {
  background: url(../../assets/imgs/r_phone.png) 0px 0px no-repeat;
  background-color: #fbb01f;
}
.izl-rmenu .btn-phone:hover {
  background-color: #ff811b;
}
.izl-rmenu .btn-phone .phone {
  background-color: #ff811b;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}

.izl-rmenu .btn-xs {
  background: url(../../assets/imgs/r_xs.png) 0px 0px no-repeat;
  background-color: #6cafeb;
}
.izl-rmenu .btn-xs:hover {
  background-color: #5d9fdb;
}
.izl-rmenu .btn-xs .xs {
  background-color: #5d9fdb;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}

.izl-rmenu .btn-mail {
  background: url(../../assets/imgs/r_mail.png) 0px 0px no-repeat;
  background-color: #e37677;
}
.izl-rmenu .btn-mail:hover {
  background-color: #dd6364;
}
.izl-rmenu .btn-mail .mail {
  background-color: #dd6364;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 15px;
  text-align: center;
}

.izl-rmenu .btn-top {
  background: url(../../assets/imgs/r_top.png) 0px 0px no-repeat;
  background-color: #666666;
  // display: none;
}
.izl-rmenu .btn-top:hover {
  background-color: #444;
}

//new
body {
  background: #fff;
  letter-spacing: 0px;
}
.header {
  width: 1200px !important;
  margin: 0 auto !important;
}
</style>
